import { Travelers } from '@booking/entities/booking-arrangement';
import { ReservationFlight } from '@user-history/entities/history-booking-detail';

export type ItineraryDetail = Readonly<{
  Id: number,
  AirReservationId: number,
  Sectors: AirValidationSector[];
  Passengers: Travelers[];
}>;

export type ItineraryHistoryDetail = Readonly<{
  Id: number,
  Reservations: ReservationFlight[],
  Status: string
}>;

export type AirValidationSector = Readonly<{
  SectorNumber: 1;
  TotalDuration: string;
  Flights: AirValidationFlightsSector[];
  IsSelected?: boolean;
}>;

export type AirValidationFlightsSector = Readonly<{
  DepartureAirport: string;
  ArrivalAirport: string;
  DepartureDate: string;
  ArrivalDate: string
  AirlineCode: string;
  BaggageRestrictions: string;
  FlightTimeInternal: string;
  OpAirlineCode: string;
  Number: number;
  Cabin: number;
  Equipment: number;
  NumberOfStops: number;
  TechnicalStopAirport: string;
  TechnicalStopTime: string;
  FareBasis: string;
  FareFamilies: string;
  IsConnectionInDifferentAirport?: boolean;
  IsSelected: boolean;
}>;

export enum TripTypes {
  DEPARTURE = 1,
  RETURN = 2
}
